import { HeroBannerSize } from './hero-banner.types';

export function getHeroBannerMinHeightClass(size: HeroBannerSize): string {
  switch (size) {
    case 'slim':
      return 'min-h-102 md:min-h-80.5';
    case 'full':
      return 'min-h-149 md:min-h-128';
    default:
      return 'min-h-126 md:min-h-113';
  }
}

export const getHeroBannerSize = (heroBannerTypeStyle?: string, fallbackSize?: HeroBannerSize): HeroBannerSize => {
  if (fallbackSize) return fallbackSize;

  const normalizedSize = typeof heroBannerTypeStyle === 'string' ? heroBannerTypeStyle.trim().toLowerCase() : undefined;

  return normalizedSize === 'full' ? 'full' : normalizedSize === 'slim' ? 'slim' : 'medium';
};
